import { Component, ChangeDetectionStrategy } from '@angular/core';
import { FieldTypeConfig, FieldType, FormlyFieldProps } from '@ngx-formly/core';

interface MultiCheckboxProps extends FormlyFieldProps {
  formCheck: 'default' | 'inline' | 'switch' | 'inline-switch';
}

@Component({
  standalone: false,
  selector: "formly-field-multicheckbox",
  templateUrl: "./multi-checkbox.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormlyFieldMultiCheckbox extends FieldType<FieldTypeConfig<MultiCheckboxProps>> {

  override defaultOptions = {
    props: {
      formCheck: 'default' as const, // 'default' | 'inline' | 'switch' | 'inline-switch'
    },
  };

  onChange(value: any, checked: boolean) {
    this.formControl.markAsDirty();
    if (this.props.type === 'array') {
      this.formControl.patchValue(
        checked
          ? [...(this.formControl.value || []), value]
          : [...(this.formControl.value || [])].filter((o) => o !== value),
      );
    } else {
      this.formControl.patchValue({ ...this.formControl.value, [value]: checked });
    }
    this.formControl.markAsTouched();
  }

  isChecked(option: any) {
    const value = this.formControl.value;

    return value && (this.props.type === 'array' ? value.indexOf(option.value) !== -1 : value[option.value]);
  }

}